import React from 'react';
import styled from 'styled-components';

// Import your feature components
import NPSSurveyAnalysis from './components/platform/NPSSurveyAnalysis';
// IMPORT other feature components similar to the above

const PageContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 20px;
`;

const Header = styled.header`
  text-align: center;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
`;

const FeaturesSection = styled.section`
  
`;

const PlatformOverviewPage = () => {
  return (
    <PageContainer>

      <FeaturesSection>
        <NPSSurveyAnalysis />
        {/* Place other feature components here as they are developed */}
      </FeaturesSection>
    </PageContainer>
  );
};

export default PlatformOverviewPage;